import { environment } from '../../environments/environment';

export const apiConfig = {
  MAIN_URL: environment.APIEndpoint,
  GMAIL_URL: environment.GmailAPIEndpoint,
  TRANSACT: environment.TransactionPlatform,
  GOAL: environment.GoalPlatform,
  USER: environment.UserUrl,
  MF_URL: environment.mfProject,
  MARKET_PLACE: environment.MarketPlaceUrl,
  PRODUCTION: environment.production,
  RM_URL: environment.RM,
  LOCAL_URL: environment.LocalEndPoint,
  LOCAL_DEV_URL: environment.LocalDevEndPoint,
  PRICING_URL: environment.PricingTest,
  // Prod_local: environment.Prod_local
  // POSTAL_URL : environment.PostalUrl,
  // CALENDAR_URL: environment.CalendarAPIEndpoint
};
